export const AUTH_STATES = {
  ANONYMOUS: 'ANONYMOUS',
  IDENTIFIED: 'IDENTIFIED',
  REMEMBERED: 'REMEMBERED',
  PARTIALLY_AUTHENTICATED: 'PARTIALLY_AUTHENTICATED',
  LOGGED_IN: 'LOGGEDIN',
}

export const FUNNEL = {
  SEND: 'SEND',
  REQUEST: 'REQUEST',
  CONTACT: 'CONTACT',
  MORE: 'MORE',
  CONSOLIDATED: 'CONSOLIDATED',
}

export const PRODUCT_FLOWS = {
  REQUEST: 'REQUEST_MONEY',
  SEND: 'SEND_MONEY',
  CONSOLIDATED: 'MONEY_MOVEMENT_FLOW',
}

export const PRODUCT_FLOW_IDENTIFIERS = {
  DONATE: 'DONATE',
  GROUP_CONTRIBUTION: 'GROUP_CONTRIBUTION',
  PAY_REQUEST: 'PAY_REQUEST',
  PAYPAL_SHOPS: 'PAYPAL_SHOPS',
  SEND_AGAIN: 'SEND_AGAIN',
  SEND_MONEY: 'SEND_MONEY',
  SEND_MONEY_REFERRAL: 'SEND_MONEY_REFERRAL',
  UNKNOWN: 'UNKNOWN',
}

export const PAYMENT_PROCESSORS = {
  PAYPAL: 'PAYPAL',
  XOOM: 'XOOM',
}

/**
 * @IMPORTANT
 * ENV_TYPE !== ANALYTICS_FLOW_TYPE
 * Environment types should be used for external flows and integrations and can
 * alter the experience, such as "/myaccount/transfer/homepage/external/donate".
 */
export const ENV_TYPE = {
  PROFILE: 'profile',
  DONATE: 'donate',
  PAY_REQUEST: 'payRequest',
  PAR: 'par',
  SUMMARY: 'summary',
  POOLS: 'pools',
  GROUPS: 'groups',
  WALLET: 'wallet',
  MESSAGES: 'messages',
  PPSHOPS: 'shops',
  PISP: 'pisp',
  CROSS_BORDER: 'xb',
  HAWK: 'hawk',
  HAWK_PPCP: 'hawk-ppcp',
  MPP: 'mpp',
  TRICOUNT: 'tricount',
  NATIVE_MERCHANT: 'nativeMerchant',
  SPLIT: 'split',
  HOME_INFO: 'homeinfo',
  INTERNATIONAL: 'international',
}

/**
 * @IMPORTANT
 * ANALYTICS_FLOW_TYPE !== ENV_TYPE
 * Analytics flow types are used for instrumentation purposes to identify where
 * the user is "originatedFrom", as well as for "product_flow.identifier" used
 * for assess capabilities. For example: "/myaccount/transfer?from=Header".
 */
export const ANALYTICS_FLOW_TYPE = {
  PP_ME: 'ppme',
  PROFILE: 'profile',
  DONATE: 'donate',
  PAY_REQUEST: 'payRequest',
  PAR: 'par',
  SUMMARY: 'summary',
  POOLS: 'pools',
  GROUPS: 'groups',
  ACTIVITY: 'Activity',
  MARKETING: 'marketing',
  NAV_HEADER: 'Header',
  SUMMARY_RESEND: 'SUM-QuickSend', // summary send again
  SUMMARY_LINK: 'SUM-QuickLink', // summary quick send button
  CONTROL_SUM: 'ControlSUM',
  MESSAGES: 'messages',
  PISP: 'pisp',
  TRICOUNT: 'tricount',
  HOME_INFO: 'homeinfo',
  OTHER: 'Other', // unidentified flow
}

/**
 * SUB_FLOW is used as a dictionary to add the `sub_flow` FPTI property
 */
export const SUB_FLOW = {
  SEND_MONEY: 'send_money',
  SEND_MONEY_GUEST: 'send_money_guest',
  GROUPS: 'pools',
  GROUPS_GUEST: 'pools_guest',
  MONEY_MOVEMENT: 'money_movement',
}

export const SHIPPING_TYPES = {
  FLAT_RATE: 'FLAT_RATE',
  FREE: 'FREE',
  NOT_APPLICABLE: 'NOT_APPLICABLE',
}

export const ACCOUNT_TYPE = {
  PERSONAL: 'PERSONAL',
  PREMIER: 'PREMIER',
  BUSINESS: 'BUSINESS',
}

// payment type
export const PAYMENT_TYPE = {
  PURCHASE: 'PURCHASE',
  PERSONAL: 'PERSONAL',
  UNKNOWN: 'UNKNOWN',
  DONATION: 'DONATION',
}

// instrument type
export const INSTRUMENT_TYPES = {
  HOLDING: 'HOLDING',
  PAYMENT_CARD: 'PAYMENT_CARD',
  PAYMENT_TOKEN: 'PAYMENT_TOKEN',
  BANK_ACCOUNT: 'BANK_ACCOUNT',
  CREDIT: 'CREDIT',
  UNKNOWN: 'UNKNOWN',
}

// V2 InstrumentType
export const INSTRUMENT_TYPE = {
  BALANCE: 'BALANCE',
  BANK: 'BANK',
  CARD: 'CARD',
  PAYMENT_TOKEN: 'PAYMENT_TOKEN',
  CREDIT: 'CREDIT',
}

export const BANK_ACCOUNT_TYPE = {
  CURRENT: 'CURRENT',
  SAVINGS: 'SAVINGS',
}

export const FUNDING_SOURCE_TAG = {
  PREFERRED_INSTRUMENT: 'PREFERRED_INSTRUMENT',
  DYNAMIC_CURRENCY_CONVERSION: 'DYNAMIC_CURRENCY_CONVERSION',
  CASH_ADVANCE_FEES_APPLICABLE: 'CASH_ADVANCE_FEES_APPLICABLE',
  PROMO_FINANCING_APPLICABLE: 'PROMO_FINANCING_APPLICABLE',
  PROMO_FINANCING_NOT_APPLICABLE: 'PROMO_FINANCING_NOT_APPLICABLE',
  PROMO_FINANCING_ELIGIBLE: 'PROMO_FINANCING_ELIGIBLE',
  PROMO_FINANCING_INELIGIBLE: 'PROMO_FINANCING_INELIGIBLE',
  INSTRUMENT_DECLINED: 'INSTRUMENT_DECLINED',
  QUASI_CASH: 'QUASI_CASH',
}

export const FUNDING_SOURCE_CLIENT_TAGS = {
  INSTRUMENT_DECLINED: 'instrumentDeclined',
}

export const PP_CREDIT_PROMO_STATE = {
  NOT_APPLICABLE: 'NOT_APPLICABLE',
  ELIGIBLE: 'ELIGIBLE',
  INELIGIBLE: 'INELIGIBLE',
}

// analytics call them differently 😂
export const ANALYTIC_TYPE = {
  PURCHASE: 'gs',
  PERSONAL: 'ff',
  UNKNOWN: 'none',
}

export const CONSENT_TYPE = {
  SIGNUP_FOR_NETWORK_ID: 'SIGNUP_FOR_NETWORK_ID',
  PROVIDE_ADDITIONAL_NETWORK_ID_CONSENT:
    'PROVIDE_ADDITIONAL_NETWORK_ID_CONSENT',
  UPGRADE_NETWORK_ID: 'UPGRADE_NETWORK_ID',
  SIGN_UP_FOR_PUBLIC_IDENTITY: 'SIGNUP_FOR_NETWORK_ID',
  PROVIDE_PUBLIC_IDENTITY_CONSENT: 'PROVIDE_ADDITIONAL_NETWORK_ID_CONSENT',
  UPGRADE_PUBLIC_IDENTITY: 'UPGRADE_NETWORK_ID',
}

export const MONEY_PAGE = {
  CONTROL_WEB: 'CONTROL_WEB',
  DEFAULT_ON_REVIEW: 'DEFAULT_ON_REVIEW',
  CTRL_CONTENT_V2_WEB: 'CTRL_CONTENT_V2_WEB', // T12
  CTRL_CONTENT_V2_ORDER_WEB: 'CTRL_CONTENT_V2_ORDER_WEB', // T13
  CTRL_VENMO_CONTENT_MESSAGE_WEB: 'CTRL_VENMO_CONTENT_MESSAGE_WEB', // T14
}

// for historic reasons we call PERSONAL and PURCHASE different things
// this maps different terms
export const transactionTypeMap = {
  PERSONAL: PAYMENT_TYPE.PERSONAL,
  personal: PAYMENT_TYPE.PERSONAL,
  GOODS: PAYMENT_TYPE.PURCHASE,
  goods: PAYMENT_TYPE.PURCHASE,
  PURCHASE: PAYMENT_TYPE.PURCHASE,
  purchase: PAYMENT_TYPE.PURCHASE,
  SEND: PAYMENT_TYPE.PERSONAL,
  send: PAYMENT_TYPE.PERSONAL,
  BUY: PAYMENT_TYPE.PURCHASE,
  buy: PAYMENT_TYPE.PURCHASE,
  FF: PAYMENT_TYPE.PERSONAL,
  ff: PAYMENT_TYPE.PERSONAL,
  GS: PAYMENT_TYPE.PURCHASE,
  gs: PAYMENT_TYPE.PURCHASE,
  UNKNOWN: PAYMENT_TYPE.UNKNOWN,
  unknown: PAYMENT_TYPE.UNKNOWN,
}

export const analyticMap = {
  PERSONAL: ANALYTIC_TYPE.PERSONAL,
  personal: ANALYTIC_TYPE.PERSONAL,
  GOODS: ANALYTIC_TYPE.PURCHASE,
  goods: ANALYTIC_TYPE.PURCHASE,
  PURCHASE: ANALYTIC_TYPE.PURCHASE,
  purchase: ANALYTIC_TYPE.PURCHASE,
  SEND: ANALYTIC_TYPE.PERSONAL,
  send: ANALYTIC_TYPE.PERSONAL,
  BUY: ANALYTIC_TYPE.PURCHASE,
  buy: ANALYTIC_TYPE.PURCHASE,
  FF: ANALYTIC_TYPE.PERSONAL,
  ff: ANALYTIC_TYPE.PERSONAL,
  GS: ANALYTIC_TYPE.PURCHASE,
  gs: ANALYTIC_TYPE.PURCHASE,
  UNKNOWN: ANALYTIC_TYPE.UNKNOWN,
  unknown: ANALYTIC_TYPE.UNKNOWN,
}

export const PAYEE_TYPES = {
  EMAIL: 'EMAIL',
  PHONE: 'PHONE',
  ACCOUNT_NUMBER: 'ACCOUNT_NUMBER',
  PAYPALME_PROFILE: 'PAYPALME_PROFILE', // V1 Only
  PAYPAL_PROFILE: 'PAYPAL_PROFILE', // V2 Only
}

export const PAYEE_TAG = {
  CIP: 'CIP',
  RESTRICTED_ACCOUNT: 'RESTRICTED_ACCOUNT',
}

export const PHONE_TYPE = {
  MOBILE: 'MOBILE',
  HOME: 'HOME',
}

export const CONTINGENCY = {
  CONSENT: 'OBTAIN_REAL_TIME_BALANCE_CONSENT',
  REFRESH: 'REFRESH_REAL_TIME_BALANCE',
  // This is a made up contingency, it is never returned in the plan
  // it is used by us to trigger CONSENT flow while resolving REFRESH contingency.
  // It only happens when resolve(REFRESH) throws CONTINGENCY_ERRORS.INVALID_LOGIN
  INVALID_CREDENTIALS: 'REFRESH_REAL_TIME_BALANCE_INVALID_CREDENTIALS',
}

export const CONTINGENCY_ERRORS = {
  INVALID_LOGIN: 'REFRESH_CONTINGENCY_INVALID_LOGIN_CREDENTIALS',
  UNAVAILABLE: 'PAYER_FUNDING_INSTRUMENTS_UNAVAILABLE',
  DENIED: 'PAYMENT_DENIED',
}

export const FREEP2P_TYPE = {
  NON_EU: 'FREEP2P_NON_EU',
  EU: 'FREEP2P_EU',
  INAPPLICABLE: 'FREEP2P_INAPPLICABLE',
}

export const CREDIT_ACCOUNT_TYPE = {
  BUYER_CREDIT_VIRTUAL_LINE: 'BUYER_CREDIT_VIRTUAL_LINE',
  CLOSE_ENDED: 'CLOSE_ENDED',
  DUAL_CARD_EBAY: 'DUAL_CARD_EBAY',
  DUAL_CARD_PLUS: 'DUAL_CARD_PLUS',
  OPEN_ENDED: 'OPEN_ENDED',
  TXN_CARD_BML: 'TXN_CARD_BML',
  TXN_CARD_PAY_LATER: 'TXN_CARD_PAY_LATER',
  GENERIC_CREDIT: 'GENERIC_CREDIT',
}

export const DISALLOWED_FUNDING_SOURCE_REASONS = {
  RECEIVER_PREFERENCE: 'RECEIVER_PREFERENCE',
  SENDER_PREFERENCE: 'SENDER_PREFERENCE',
  INSTRUMENT_EXPIRED: 'INSTRUMENT_EXPIRED',
  INSTRUMENT_DECLINED: 'INSTRUMENT_DECLINED',
  UNSUPPORTED_PAYMENT_TYPE: 'UNSUPPORTED_PAYMENT_TYPE',
  UNSUPPORTED_CURRENCY: 'UNSUPPORTED_CURRENCY',
  CIP_VERIFICATION_NOT_STARTED: 'CIP_VERIFICATION_NOT_STARTED',
  CIP_VERIFICATION_PENDING_REVIEW: 'CIP_VERIFICATION_PENDING_REVIEW',
}

export const FUNDING_MODE = {
  INSTANT: 'INSTANT',
  DELAYED: 'DELAYED',
}

export const REVIEW_INFO_LABEL_KEYS = {
  ESTIMATED: 'label.estimatedDelivery',
  PAYMENT: 'label.paymentDelivery',
}

// Plan level contingencies
// https://github.paypal.com/pages/cdjohnston/p2pgatewaystaticdocs/paymentcontingencyaction.doc.html
export const PAYMENT_CONTINGENCY_ACTIONS = {
  DISPLAY_SCAM_WARNING: 'DISPLAY_SCAM_WARNING',
  PURCHASE_CONSENT_REQUIRED: 'PURCHASE_CONSENT_REQUIRED',
  USER_AGREEMENT_CONSENT_REQUIRED: 'USER_AGREEMENT_CONSENT_REQUIRED',
  SENDER_CIP_VERIFICATION_REQUIRED: 'SENDER_CIP_VERIFICATION_REQUIRED',
  PURPOSE_CODE_COLLECTION_REQUIRED: 'PURPOSE_CODE_COLLECTION_REQUIRED',
}

export const PURPOSE_CODE_EXPERIENCE_SELECTOR = { SHOW: 'SHOW', HIDE: 'HIDE' }

// https://github.paypal.com/pages/cdjohnston/p2pgatewaystaticdocs/contingencystatus.doc.html
export const CONTINGENCY_STATUS = {
  RESOLVED: 'RESOLVED',
  UNRESOLVED: 'UNRESOLVED',
  RESOLUTION_FAILED: 'RESOLUTION_FAILED',
}

// Funding option level contingencies
// https://github.paypal.com/pages/cdjohnston/p2pgatewaystaticdocs/contingencyaction.doc.html
export const CONTINGENCY_ACTIONS = {
  USER_DATA_COLLECTION_REQUIRED: 'USER_DATA_COLLECTION_REQUIRED',
  CARD_VERIFICATION_DATA_COLLECTION_REQUIRED:
    'CARD_VERIFICATION_DATA_COLLECTION_REQUIRED',
  THREE_D_SECURE_DATA_COLLECTION_REQUIRED:
    'THREE_D_SECURE_DATA_COLLECTION_REQUIRED',
  THREE_D_SECURE_AUTHENTICATION_REQUIRED:
    'THREE_D_SECURE_AUTHENTICATION_REQUIRED',
  OBTAIN_REAL_TIME_BALANCE_CONSENT: 'OBTAIN_REAL_TIME_BALANCE_CONSENT',
  REFRESH_REAL_TIME_BALANCE: 'REFRESH_REAL_TIME_BALANCE',
  TOPUP_INSTRUMENT: 'TOPUP_INSTRUMENT',
  PERFORM_DATA_COLLECTION: 'PERFORM_DATA_COLLECTION',
}

// Scam contingency
// https://github.paypal.com/pages/cdjohnston/p2pgatewaystaticdocs/scamwarningtype.doc.html
export const SCAM_WARNING_TYPES = {
  LOW_RISK: 'LOW_RISK',
  MEDIUM_RISK: 'MEDIUM_RISK',
  HIGH_CONFIDENCE_COMMERCE: 'HIGH_CONFIDENCE_COMMERCE',
  HIGH_RISK_DECLINED: 'HIGH_RISK_DECLINED',
}

// https://github.paypal.com/pages/cdjohnston/p2pgatewaystaticdocs/scamwarningcustomerchoice.doc.html
export const SCAM_WARNING_CUSTOMER_CHOICES = {
  ACCEPT_PAYMENT_TYPE: 'ACCEPT_PAYMENT_TYPE',
  UPDATE_PAYMENT_TYPE_TO_PURCHASE: 'UPDATE_PAYMENT_TYPE_TO_PURCHASE',
}

export const WARNING_INFORMATION_URLS = {
  LEARN_ABOUT_SCAMS: '/:country/cshelp/article/help1165',
  PURCHASE_PROTECTION_INFO: '/webapps/mpp/paypal-safety-and-security',
}

// Other
export const USER_DATA_COLLECTION_ATTRIBUTES = {
  SENDER_GOVERNMENT_ID: 'SENDER_GOVERNMENT_ID',
  SENDER_ADDRESS: 'SENDER_ADDRESS',
  RECEIVER_NAME: 'RECEIVER_NAME',
  RECEIVER_COUNTRY_CODE: 'RECEIVER_COUNTRY_CODE',
}

export const STORY_ERRORS = {
  // Send message errors
  FAILED_TO_SEND: 'FAILED_TO_SEND',
  FAILED_TO_SEND_NO_RETRY: 'FAILED_TO_SEND_NO_RETRY',
  RESOURCE_NOT_FOUND: 'RESOURCE_NOT_FOUND',
  FIELD_NOT_PATCHABLE: 'FIELD_NOT_PATCHABLE',
  ACCOUNT_LEVEL_RESTRICTION: 'ACCOUNT_LEVEL_RESTRICTION',
  MESSAGE_CONTAINS_SENSITIVE_DATA: 'MESSAGE_CONTAINS_SENSITIVE_DATA',
  MESSAGES_ALLOWED_ONLY_ON_ACTIVE_STORIES:
    'MESSAGES_ALLOWED_ONLY_ON_ACTIVE_STORIES',

  // Loading story errors
  UNABLE_TO_LOAD_STORY_DETAILS: 'UNABLE_TO_LOAD_STORY_DETAILS',
  UNABLE_TO_LOAD_STORY_DETAILS_CHECK_CONNECTION:
    'UNABLE_TO_LOAD_STORY_DETAILS_CHECK_CONNECTION',
}

export const PAYMENT_STATUSES = {
  PENDING: 'PENDING',
  UNDER_REVIEW: 'UNDER_REVIEW',
}

export const PAYMENT_PENDING_REASONS = {
  PAYMENT_HOLD: 'PAYMENT_HOLD',
}

export const REGULATORY_PENDING_REASONS = {
  REGULATORY_REVIEW: 'REGULATORY_REVIEW',
}

export const REGULATORY_RULE_TYPES = {
  OFAC: 'OFAC',
}

export const SHIPPING_ADDRESS_COLLECTION_PREFERENCES = {
  HIDE: 'HIDE',
  DEFAULT_TO_NONE: 'DEFAULT_TO_NONE',
  DEFAULT_TO_PRIMARY: 'DEFAULT_TO_PRIMARY',
}

export const SHIPPING_ADDRESS_OPTIONS = {
  NO_ADDRESS_NEEDED: 'noAddressNeeded',
  ADD_ADDRESS: 'handleAddAddress',
}

export const DISCLOSURE_TYPES = {
  PRE_TRANSACTION_REMITTANCE_DISCLOSURES:
    'PRE_TRANSACTION_REMITTANCE_DISCLOSURES',
  POST_TRANSACTION_REMITTANCE_DISCLOSURES:
    'POST_TRANSACTION_REMITTANCE_DISCLOSURES',
  DELAYED_DEBIT_DISCLOSURES: 'DELAYED_DEBIT_DISCLOSURES',
  PAYMENT_HOLD_DISCLOSURES: 'PAYMENT_HOLD_DISCLOSURES',
  USER_AGREEMENT_DISCLOSURES: 'USER_AGREEMENT_DISCLOSURES',
  FOREIGN_TAX_DISCLOSURES: 'FOREIGN_TAX_DISCLOSURES',
  FRAUDULENT_ACTIVITY_DISCLOSURES: 'FRAUDULENT_ACTIVITY_DISCLOSURES',
  PAYMENT_REVIEW_DISCLOSURES: 'PAYMENT_REVIEW_DISCLOSURES',
  DISPLAY_ADD_INSTRUMENT_FEE_DISCLOSURES:
    'DISPLAY_ADD_INSTRUMENT_FEE_DISCLOSURES',
  PAYMENT_PROCESSED_DISCLOSURES: 'PAYMENT_PROCESSED_DISCLOSURES',
  PAYMENT_TYPE_DISCLOSURES: 'PAYMENT_TYPE_DISCLOSURES',
  INSUFFICIENT_FUNDS_DISCLOSURE: 'INSUFFICIENT_FUNDS_DISCLOSURE',
}

export const PAYMENT_TYPES = {
  INSTANT_PAYMENT: 'INSTANT_PAYMENT',
  RECEIVER_SIGNUP: 'RECEIVER_SIGNUP',
  RECEIVER_PREFERENCE: 'RECEIVER_PREFERENCE',
  PAYMENT_HOLD: 'PAYMENT_HOLD',
  REGULATORY_REVIEW: 'REGULATORY_REVIEW',
}

export const FRAUD_DISCLOSURE_TYPES = {
  STATE_MANDATED_WARNING: 'STATE_MANDATED_WARNING',
}

export const PAYMENT_REVIEW_DISCLOSURE_TYPES = {
  PAYMENT_CANCELLATION_DISALLOWED: 'PAYMENT_CANCELLATION_DISALLOWED',
}

export const PROFILE_STATUS = {
  SHARE_PROFILES: 'SHARE_PROFILES',
  SIGNUP_FOR_PROFILES: 'SIGNUP_FOR_PROFILES',
  ACTIVATE_PROFILES: 'ACTIVATE_PROFILES',
}

export const SELLER_PROFILE_STATUS = {
  SHARE_SELLER_PROFILE: 'SHARE_SELLER_PROFILE',
  SIGN_UP_FOR_SELLER_PROFILE: 'SIGN_UP_FOR_SELLER_PROFILE',
  ACTIVATE_SELLER_PROFILE: 'ACTIVATE_SELLER_PROFILE',
  INELIGIBLE_FOR_SELLER_PROFILE: 'INELIGIBLE_FOR_SELLER_PROFILE',
}

export const ERROR_AUTH_REQUIRED = 'authRequired'
export const ERROR_MISSING_REQUIRED_PARAM = 'MISSING_REQUIRED_PARAMETER'
export const ERROR_MISSING_REQUIRED_NOTE_FIELD = 'MISSING_REQUIRED_NOTE_FIELD'
export const ERROR_NOTE_TO_RECEIVER_IS_MANDATORY =
  'NOTE_TO_RECEIVER_IS_MANDATORY'
export const ERROR_REQUESTEE_SEARCH_PREFERENCES_NOT_ENABLED =
  'REQUESTEE_SEARCH_PREFERENCES_NOT_ENABLED'

export const NOTE_VARIANTS = {
  CORE_MARKETS: 'CORE_MARKETS',
  GLOBAL_MARKETS: 'GLOBAL_MARKETS',
  THAILAND: 'THAILAND',
}

export const GROWTH_PRODUCT_FLOWS = {
  SEND_MONEY: 'send_money',
}
export const REQUIRED_FLOW_ATTRIBUTES = { NOTE_TO_RECEIVER: 'NOTE_TO_RECEIVER' }

export const SUMMARY_PAGE_URL = '/myaccount/summary'

export const REQUEST_MAX_CHAR_LIMIT = 1500

export const NUM_TOP_CONTACTS = 7

export const SEARCH_INPUT_WIDTH = 606

export const REQUEST_HEADERS = {
  ACCEPT_LANGUAGE: 'accept-language',
  APPLICATION_CONTEXT: 'PayPal-Application-Context',
  PAYPAL_ENTRY_POINT: 'paypal-entry-point',
  PAYPAL_CLIENT_METADATA_ID: 'paypal-client-metadata-id',
}

export const CONTACT_TAGS = {
  MOBILE_CONTACT: 'MOBILE_CONTACT',
}

export const ERROR_MESSAGES = {
  CVV_LENGTH: 'Incorrect CVV length',
  CVV_VERIFICATION: 'CVV Verification failed',
  PARSING_DECRYPTED_DATA: 'Failed to parse decrypted data',
}

export const PAYMENT_ORIGINATION = {
  PAYPAL: 'PAYPAL.COM',
}

export const PARAMS_ENV = 'params.env'

export const DEVICE_TYPE = {
  ANDROID: 'AND',
  IOS: 'IOS',
}

export const SPF_TEMPLATES = {
  PUBLIC_PROFILE: 'profilePage',
}

export const BOOKMARK_SEARCH_TYPES = {
  BOOKMARK_SEARCH: 'description',
  BOOKMARK_PEER: 'peer_id',
  BOOKMARK_NETWORK_TYPE: 'P2P',
  PEER_TYPES: {
    STRING: 'STRING',
    USER: 'USER',
    SELLER_PROFILE: 'BUSINESS_IDENTITY',
  },
  SUGGESTION_TYPES: {
    EMAIL_OR_PHONE: 'EMAIL_OR_PHONE',
    STRING: 'STRING',
    CONTACT: 'CONTACT',
  },
}

export const SENDER_CIP_VERIFICATION = {
  CONTINGENCY_NAME:
    PAYMENT_CONTINGENCY_ACTIONS.SENDER_CIP_VERIFICATION_REQUIRED,
  POLICY: 'CA_CIP',
  VERIFY_ACTION: 'VERIFY',
  REL: 'verify-cip',
}

export const EDITABLE_FLOW_ATTRIBUTES = {
  RECEIVER: 'RECEIVER',
  // Currency code and amount are considered the same enum ('AMOUNT')
  CURRENCY_CODE: 'AMOUNT',
  AMOUNT: 'AMOUNT',
  NOTE: 'NOTE_TO_RECEIVER',
  PAYMENT_TYPE: 'PAYMENT_TYPE',
  ANONYMOUS_GROUP_CONTRIBUTION: 'ANONYMOUS_GROUP_CONTRIBUTION',
}

export const SUGGESTED_ACTIONS = {
  ADD_FINANCIAL_INSTRUMENT: 'ADD_FINANCIAL_INSTRUMENT',
}

export const TRANSACTION_STATUS = {
  REVERSED: 'REVERSED',
  COMPLETED: 'COMPLETED',
}

export const INVALID_INPUT_PARAMETERS = 'INVALID_INPUT_PARAMETERS'

export const GROUPS_URL = '/pool'
export const BILL_SPLIT_SUCCESS = 'SUCCESS'

export const TOAST_DURATION = '60000'

export const TOAST_TYPES = {
  SUCCESS: 'success',
}

export const DISCOVERABILITY = {
  EUROPE_SIMPLIFIED_POLICY: 'EUROPE_SIMPLIFIED',
  OPT_IN_CONSENT_TYPE: 'OPT_IN_DEFAULT',
}

export const INTEGRATION_TYPE = {
  CLAIM_PAYOUTS: 'p2pclaimpayouts',
  CLAIM_MONEY: 'p2pclaimmoney',
}

export const MINIMAL_ACCOUNT_CREATION_LIMITATION_RESTRICTION_UX =
  'MINIMAL_ACCOUNT_CREATION_LIMITATION_RESTRICTION_UX'

export const P2P_HOMEPAGE_URL = '/myaccount/transfer/homepage'

export const SPF_VERSION = '1.20.0'

export const HEADERS = {
  P2P_INTEGRATION_IDENTIFIER: 'P2P-INTEGRATION-IDENTIFIER',
  PAYMENT_CHANNEL: 'PAYMENT-CHANNEL',
}

export const INTEGRATION_IDENTIFIERS = {
  '8BALL': '8BALL',
}
